/**
 * Enum group column Khóa sổ kỳ kế toán
 */
export default {
  ref_type: 1, // Loại chứng từ
  ref_date: 2, // Ngày chứng từ
  posted_date: 3, // Ngày hạch toán
  ref_no: 4, // Số chứng từ
  type_edit: 5, // Hình thức xử lý
};
